module.exports = __webpack_public_path__ + "static/media/ic-1.bf6218ee.svg";